import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const abnormalBloodSugar: AnswerPathTreeNode = {
  path: 'abnormalBloodSugar',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAbnormalBloodSugarDetails }],
};
